import React, { useState } from "react";
import { RoundShape } from "../Assets";
import { Rating } from "@mui/material";

const FeedbackPage = () => {
  const [clientIndex, setClientIndex] = useState(0);

  const clients = [
    
    {
      clientName: "Luis Garavito",
      clientPosition: "lgaravito@flyjetedge.com",
      clientProfile:
        "https://spet-gatsby.envytheme.com/static/team1-61718ea9ddf4b0ebc46df50d4b243d60.jpg", // You can replace with actual profile image URL
      feedBack: `Continue doing a great job. Make sure JetEdge gives clear direction of expectations and that expectations are real.`,
      rating: 4,
    },
    // New feedback entries added below
    {
      clientName: "Luis Garavito",
      clientPosition: "JetEdge",
      clientProfile:
        "https://spet-gatsby.envytheme.com/static/team1-61718ea9ddf4b0ebc46df50d4b243d60.jpg", // Replace with actual profile image URL if available
      feedBack: `“Continue doing a great job. The application and support have been excellent, with clear communication and well-managed expectations throughout.”`,
      rating: 5,
    },
    {
      clientName: "Jorge Perez",
      clientPosition: "Vista America",
      clientProfile:
         "https://spet-gatsby.envytheme.com/static/team4-a173f6b45cbf8f3527f4a706200da300.jpg", // Replace with actual profile image URL if available
      feedBack: `“The portal works great for our team’s daily operations and provides a smooth overall experience. While there are occasional minor challenges, the platform continues to perform reliably and supports our workflow effectively.”`,
      rating: 4,
    },
    {
      clientName: "Jessica Sanchez",
      clientPosition: "JetEdge",
      clientProfile:
      "https://spet-gatsby.envytheme.com/static/team3-b26ea03987d2cdfc20d9f1268677dcf5.jpg", 
   
      feedBack: `“The IT support team has been very responsive and helpful. Having responses maintained within the same email thread would make it even easier to track requests and keep communication more streamlined.”`,
      rating: 4,
    },
  ];

  const handleNext = () => {
    if (clientIndex !== clients.length - 1) {
      setClientIndex(clientIndex + 1);
    }
  };

  const handlePrev = () => {
    if (clientIndex !== 0) {
      setClientIndex(clientIndex - 1);
    }
  };

  return (
    <div className="ml-feedback-area ptb-50">
      <div className="container">
        <div className="section-title">
          <h2>Our Clients Feedback</h2>
          <div className="bar"></div>
        </div>
        <div className="swiper swiper-initialized swiper-horizontal ml-feedback-slides swiper-backface-hidden">
          <div
            className="swiper-wrapper"
            style={{
              transform: "translate3d(0px, 0px, 0px)",
              transitionDuration: "0ms",
            }}
          >
            {clients.map((item, index) => (
              <div
                className="swiper-slide "
                style={{ display: index === clientIndex ? "block" : "none" }}
                key={item.clientName + index} // Added index to key to ensure uniqueness
              >
                <div className="single-ml-feedback-item">
                  <div className="client-info">
                    <img src={item.clientProfile} alt="client" />
                    <h3>{item.clientName}</h3>
                    <span>{item.clientPosition}</span>
                  </div>
                  <p>{item.feedBack}</p>
                  <div className="rating">
                    <Rating
                      name="read-only"
                      value={item.rating ?? 0}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              columnGap: "50px",
              height: "65px",
            }}
          >
            <button
              className="arrow-span"
              style={
                clientIndex === 0
                  ? { opacity: 0.5, pointerEvents: "none" }
                  : { opacity: 1, pointerEvents: "auto" }
              }
              onClick={handlePrev}
            >
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="122.881px"
                height="94.163px"
                viewBox="0 0 122.881 94.163"
                enableBackground="new 0 0 122.881 94.163"
                className="left-arr"
              >
                <g>
                  <polygon
                    fillRule="evenodd"
                    clipRule="evenodd"
                    points="0,47.071 47.093,0 91.535,0 60.169,31.366 122.881,31.366 122.881,62.797 60.169,62.797 91.535,94.163 47.093,94.163 0,47.071"
                  />
                </g>
              </svg>
            </button>
            <button
              className="arrow-span"
              style={
                clientIndex === clients.length - 1
                  ? { opacity: 0.5, pointerEvents: "none" }
                  : { opacity: 1, pointerEvents: "auto" }
              }
              onClick={handleNext}
            >
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="122.878px"
                height="94.16px"
                viewBox="0 0 122.878 94.16"
                enableBackground="new 0 0 122.878 94.16"
                className="left-arr"
              >
                <g>
                  <polygon
                    fillRule="evenodd"
                    clipRule="evenodd"
                    points="122.878,47.07 75.786,0 31.344,0 62.71,31.365 0,31.365 0,62.795 62.71,62.795 31.344,94.16 75.786,94.16 122.878,47.07"
                  />
                </g>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="shape1">
        <img src={RoundShape} alt="shapesth" />
      </div>
      <div className="shape2 rotateme">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
          alt="shape"
        />
      </div>
      <div className="shape3">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOC41NjIiIGhlaWdodD0iMjguNTk0IiB2aWV3Qm94PSIwIDAgMjguNTYyIDI4LjU5NCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgICBzdHJva2U6ICNlMWUxZTE7CiAgICAgICAgc3Ryb2tlLXdpZHRoOiAzcHg7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMTQuMjgxIiBjeT0iMTQuMjk3IiByPSIxMi43ODEiLz4KPC9zdmc+Cg=="
          alt="shape"
        />
      </div>
      <div className="shape4">
        <img
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
          alt="shape"
        />
      </div>
      <div className="shape7">
        <img
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
          alt="shape"
        />
      </div>
      <div className="shape8 rotateme">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
          alt="shape"
        />
      </div>
    </div>
  );
};

export default FeedbackPage;